import React, { useState } from 'react';

import { FeatureFlagged, FeatureGatedVariant } from '../../feature-gates/feature-flagged';
import { FeatureGates } from '../../feature-gates/feature-gates';
import { TextMessage } from '../../messages/legacy-components/text-message';

import { EditMessageTemplateDialog } from './edit-message-template-dialog';
import { TextMessageTemplate } from './text-message-template';

import { confirm } from '../../widgets/confirmation-dialog';

type InputProps<T> = {
  messageBody: string;
  template: T;
  parser: MessageTemplateParser;
  recipientType: ContactType;
  templateType: TemplateType;

  editorCaption?: string;
  useRichText?: boolean;

  onSave: (template: T, options?: any) => void;
  onDelete: (template: T) => void;
};

export const InlineTextMessageTemplate = <T extends Template>({
  messageBody,
  template,
  onDelete,
  onSave,
  parser,
  editorCaption,
  useRichText,
  recipientType,
  templateType,
}: InputProps<T>) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const handleDelete = async () => {
    if (await confirm('Are you sure you would like to delete this message?')) {
      onDelete(template);
    }
  };
  const handleSave = async (newTemplate: T, options: any) => {
    setIsEditing(false);
    await onSave(newTemplate, options);
  };
  const toggleEditMessage = () => setIsEditing(!isEditing);

  return (
    <>
      <FeatureFlagged
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <TextMessage
          messageBody={messageBody}
          className="u-width-100"
          onEditMessage={toggleEditMessage}
          onDeleteMessage={handleDelete}
          includesHTML
          doNotTrim
          dataCy="template-message"
        />
      </FeatureFlagged>
      <FeatureFlagged
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
        flagName={FeatureGates.INTEGRATED_MESSAGING}
      >
        <TextMessageTemplate
          template={template}
          messageBody={messageBody}
          onEdit={toggleEditMessage}
          onDelete={onDelete}
          isSelected
        />
      </FeatureFlagged>
      {isEditing ? (
        <EditMessageTemplateDialog
          caption={editorCaption}
          onSave={handleSave}
          onClose={toggleEditMessage}
          communicationTemplate={template}
          parser={parser}
          useRichText={useRichText}
          recipientType={recipientType}
          templateType={templateType}
        />
      ) : null}
    </>
  );
};
